import React from "react";

import RefreshIcon from "@mui/icons-material/Refresh";
import { Stack } from "@mui/material";

import Button from "@src/multiCustodian/components/MUI/Button/Button";
import Text from "@src/sharedComponents/Typography/Text";

import styles from "./TransitionErrorState.module.css";

interface TransitionErrorStateProps {
  /**
   * The error message to display
   */
  message?: string;
  /**
   * Callback function when the retry button is clicked
   */
  onRetry?: () => void;
  /**
   * Text for the retry button
   */
  retryText?: string;
}

const TransitionErrorState: React.FC<TransitionErrorStateProps> = ({
  message = "Could not load data",
  onRetry,
  retryText = "Retry",
}) => {
  return (
    <Stack spacing={2} alignItems="center" justifyContent="center">
      <Stack direction="row" spacing={1} alignItems="center">
        <Text variant="body" color="textSubtle">
          {message}
        </Text>
      </Stack>
      {onRetry && (
        <Button
          text={retryText}
          size="small"
          variant="outlined"
          buttonType="primary"
          onClick={onRetry}
          endIcon={<RefreshIcon className={styles.refreshIcon} />}
        />
      )}
    </Stack>
  );
};

export default TransitionErrorState;
